import { edgeEndX, edgeStartX, maskFillX } from './Content';
import { useModulesContext } from './ModulesContext';

import './Points.css';

const CSSDotsBackground = () => {
    return (
        <div className="points-container">
            <div className="dots-layer" />
            <div className="black-overlay" />
            <div className="center-darkening" />
        </div>
    );
};

const Events = () => {
    const { events } = useModulesContext();

    return (
        <g>
            {events.map((e, i) => (
                <use href="#eventSymbol" key={i} x="-20%" y={e.y + '%'}>
                    <animate
                        attributeName="x"
                        values="-20%; 120%"
                        begin={e.begin + 'ms'}
                        dur={e.duration + 'ms'}
                        repeatCount="1"
                    />
                </use>
            ))}
        </g>
    );
};

export const PointsDefs = () => {
    return (
        <>
            <filter id="matrix">
                <feColorMatrix in="SourceGraphic" type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" />
            </filter>

            <filter id="maskBlur">
                <feGaussianBlur in="SourceGraphic" stdDeviation="50" />
            </filter>

            <filter id="blur">
                <feGaussianBlur in="SourceGraphic" stdDeviation="2" />
            </filter>

            <filter id="eventsMaskFilter">
                <feMorphology operator="dilate" radius="40" />
                <feGaussianBlur stdDeviation="40" />
            </filter>

            <pattern id="dots" width="15" height="15" fill="none" patternUnits="userSpaceOnUse">
                <circle r="1" cx="6" cy="6" fill="white"></circle>
            </pattern>

            <pattern id="dotsLarge" width="15" height="15" fill="none" patternUnits="userSpaceOnUse">
                <circle r="2" cx="6" cy="6" fill="white"></circle>
            </pattern>

            <linearGradient id="coverGradient" x1="0" x2="0" y1="0" y2="1">
                <stop offset="00%" stopColor="rgb(150, 150, 150)" />
                <stop offset="50%" stopColor="black" />
                <stop offset="100%" stopColor="rgb(255, 255, 0)" />
            </linearGradient>

            <linearGradient id="moduleInfo" x1="0" x2="1" y1="0" y2="0">
                <stop offset="0%" stopColor="black" />
                <stop offset="30%" stopColor="rgb(170, 170, 170)" />
                <stop offset="70%" stopColor="rgb(170, 170, 170)" />
                <stop offset="100%" stopColor="black" />
            </linearGradient>

            <linearGradient id="eventGradient" x1="1" x2="0" y1="0" y2="0">
                <stop offset="20%" stopColor="white" />
                <stop offset="100%" stopColor="black" />
            </linearGradient>

            <symbol id="eventSymbol" width="63" height="17" viewBox="0 0 63 17" fill="none">
                <path d="M8 8.5L55 8V9L8 8.5Z" fill="url(#eventGradient)" />
            </symbol>
        </>
    );
};

export const Points = () => {
    return (
        <>
            <foreignObject width="100%" height="100%" style={{ pointerEvents: 'none' }}>
                <CSSDotsBackground />
            </foreignObject>

            <mask id="mask">
                <rect width="100%" height="70%" y="15%" fill="url('#coverGradient')"></rect>

                <rect width="100%" height="15%" fill="black"></rect>
                <rect width="100%" height="15%" y="85%" fill="black"></rect>

                <g filter="url('#eventsMaskFilter')">
                    <Events />
                </g>

                <use
                    href="#startMask"
                    className="origin-top-right"
                    x={edgeStartX + '%'}
                    y="0%"
                    width="100%"
                    height="100%"
                />
                <use
                    href="#endMask"
                    className="origin-top-right"
                    x={edgeEndX + '%'}
                    y="0%"
                    width="100%"
                    height="100%"
                />
                <rect width={edgeEndX - maskFillX + '%'} height="100%" x={maskFillX + '%'} fill="black" />

                <rect width="60%" height="15%" x="20%" y="83%" fill="url('#moduleInfo')"></rect>
            </mask>

            <Events />
        </>
    );
};
